import { memo, useEffect, useRef, useState } from 'react'

import { Center, Loader, Stack, Text } from '@mantine/core'

import {
  useCheckPermit2,
  useSetupPermit2,
} from '@repo/common/queries/blockchain/useSetupPermit2'
import type { AddressableSymbol } from '@repo/common/queries/products'

import type { BasePanelProps } from '@/flows/flow_helpers'

export type ExtraPanelPermitProps = {
  symbol_in: AddressableSymbol
}

export const PanelPermit2 = memo<BasePanelProps & ExtraPanelPermitProps>(
  function PanelPermit2({ symbol_in, onCompleted }) {
    const permit_query = useCheckPermit2({ symbol: symbol_in })
    const { isReady, mutate } = useSetupPermit2({
      symbol: symbol_in,
    })
    const [waiting, set_waiting] = useState<boolean>(false)
    const called_ref = useRef(false)

    useEffect(() => {
      if (permit_query.data?.permit_enabled) {
        onCompleted()
      }
    }, [onCompleted, permit_query.data?.permit_enabled])

    useEffect(() => {
      if (isReady && called_ref.current == false) {
        called_ref.current = true
        mutate({ onWait: () => set_waiting(true) })
      }
    }, [isReady, mutate])

    if (waiting) {
      return (
        <Stack>
          <Text>Confirming on blockchain</Text>
          <Center w="100%">
            <Loader color="primary" type="bars" />
          </Center>
        </Stack>
      )
    }

    return (
      <Stack>
        <Text>Enable {symbol_in} permissions...</Text>
        <Text>Confirm with wallet</Text>
      </Stack>
    )
  },
)

export const useSkipPermit2 = ({
  symbol_in,
}: ExtraPanelPermitProps): boolean => {
  const permit_query = useCheckPermit2({ symbol: symbol_in })

  return permit_query.data?.permit_enabled == true
}
